import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomOrderbookIcon = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props} viewBox="0 0 18 14">
        <path d="M7 10H5V8.5H7V10Z" />
        <path d="M7 7.5H3V6H7V7.5Z" />
        <path d="M7 5H4V3.5H7V5Z" />
        <path d="M15 8.5V10H11V8.5H15Z" />
        <path d="M13 7.5H11V6H13V7.5Z" />
        <path d="M14 5H11V3.5H14V5Z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.37891 0C5.11871 0 6.85117 0.227501 8.53223 0.675781L9 0.799805L9.46777 0.675781C10.9387 0.283548 12.4487 0.0603319 13.9688 0.0107422L14.6211 0H18V13H14.4619C12.8386 13 11.2334 13.3407 9.75 14H8.25C6.85919 13.3819 5.36129 13.0437 3.8418 13.0039L3.53809 13H0V0H3.37891ZM1.5 11.5H3.53809C5.15117 11.5 6.74836 11.7982 8.25 12.377V2.15234L8.14551 2.125C6.5906 1.71038 4.98814 1.5 3.37891 1.5H1.5V11.5ZM14.6211 1.5C13.0119 1.5 11.4094 1.71038 9.85449 2.125L9.75 2.15234V12.377C11.2516 11.7982 12.8488 11.5 14.4619 11.5H16.5V1.5H14.6211Z"
        />
    </SvgIcon>
);
